import API from "./API";

export default class JobsPlanner extends API
{
    static async search(params) {
        return await this.get("api/admin/jobsplanner", {params: params});
    }

    static async create(params) {
        return await this.post("api/admin/jobsplanner", params);
    }

    static async delete(id) {
        return await API.delete("api/admin/jobsplanner/" + id);
    }

}

